/* esm.sh - rxjs@7.8.2/dist/esm/internal/symbol/observable */
var o=typeof Symbol=="function"&&Symbol.observable||"@@observable";export{o as observable};
//# sourceMappingURL=observable.mjs.map